import {
  Dropdown,
  ListTabsPanel
} from 'common/components'
import {Button} from 'common/components/V2'
import useStore from 'base/store'
import { Space, Upload } from 'antd'
import { useExportClients, useImportProject } from '../api'

const tabs = [
  {key: '', label: 'Current projects'},
  {
    key: 'closed',
    label: 'Closed projects',
  },
]

const reportMenuItems = [
  {key: 'template', label: 'template'},
  {key: 'xeroClients', label: 'xeroClients'},
]

export default function ProjectsPanel() {
  const { email } = useStore(state => state.userInfo);
  const {mutate: uploadFile, isMutating: isUploading} = useImportProject();
  const importPermission = process.env.REACT_APP_IMPORT_PERMISSION;
  const { mutate: exportClients } = useExportClients();

  return (
    <ListTabsPanel
      path="projects"
      tabs={tabs}
      action={
        // 配置文件需要先配置后部署
        importPermission.includes(email) && (
          <Space>
            <Upload
              name="file"
              accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              showUploadList={false}
              disabled={isUploading}
              customRequest={({file}: any) => uploadFile(file)}
            >
              <Button
                $color='cyan'
                $size='small'
              >
                import
              </Button>
            </Upload>
            <Dropdown
              menu={{
                items: reportMenuItems,
                onClick: ({key}: any) => exportClients(key),
              }}
              placement="bottomRight"
            >
              <Button
                $color='cyan'
                $size='small'
              >
                export
              </Button>
            </Dropdown>
          </Space>
        )
      }
    />
  )
}
